<template>
  <div class="m-adaptimg-wrapper">
    <img
      v-scroll-in-view-once="show"
      :src="imgsrc"
      ref="img"
      :style="adjustSty"
    >
  </div>
</template>

<script>
import preload from '@/assets/images/preload.png'
import scrollInViewOnce from '@/directive/onceScrollInView'
import {isObjectFitCompatible} from '@/utils/index'
export default {
  directives: {
    scrollInViewOnce
  },

  data () {
    return {
      preload,
      adjustSty: {},
      imgsrc: preload
    }
  },

  props: {
    src: {
      type: String
    }
  },

  methods: {
    show () {
      this.imgsrc = this.src
      this.$refs.img.addEventListener('load', () => {
        if (this.$refs.img.src !== this.src) return
        this.adapt()
      })
    },

    adapt () {
      if (isObjectFitCompatible) {
        this.adjustSty = {
          width: '100%',
          height: '100%',
          'object-fit': 'cover'
        }
        return
      }
      let img = this.$refs.img
      const boxRatio = this.$el.clientWidth / this.$el.clientHeight
      const imgRatio = img.width / img.height
      let width, height, top, left
      if (imgRatio < boxRatio) {
        width = '100%'
        height = this.$el.clientWidth / imgRatio
        left = 0
        top = `-${(height - this.$el.clientHeight) / 2}px`
      } else if (imgRatio > boxRatio) {
        height = '100%'
        width = this.$el.clientHeight * imgRatio
        left = `-${(width - this.$el.clientWidth) / 2}px`
        top = 0
      } else {
        width = '100%'
        height = '100%'
        top = 0
        left = 0
      }

      this.adjustSty = {
        width: width,
        left: left,
        height: height,
        top: top,
        position: 'absolute'
      }
    }
  }
}
</script>

<style scoped lang="less">
.m-adaptimg-wrapper{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// adaptImg.vue?220b932c